const { getChannelOptionsWithBatchCreateLog, getAdvertiserSourceTypeOptions } = require('@/tools');
const { CHANNEL_INTERFACE_TYPE } = require('@/enums');

module.exports = (s) => {
  return {
    channel_interface: {
      label: '媒体平台',
      type: 'select',
      options: getChannelOptionsWithBatchCreateLog(),
      on: {
        change: async() => {
          const { advertiser_id, channel_interface } = s.table_filter;
          advertiser_id.value = '';
          advertiser_id.options = channel_interface.value ? await s.getAdvertiserList(channel_interface.value) : [];
        },
      },
      value: CHANNEL_INTERFACE_TYPE.JRTT,
    },
    advertiser_id: {
      label: '广告主账户',
      type: 'select',
      options: [],
      value: '',
    },
    name: {
      label: '模板名称',
      type: 'input',
      value: '',
    },
    advertiser_source_id: {
      label: '操作目标',
      type: 'select',
      options: getAdvertiserSourceTypeOptions(),
      value: '',
    },
  };
};

